export default {
  // 侧边栏默认配置
  menu: {
    asideCollapse: true,
    asideTransition: true
  },
  page: {
    opened: []
  }
}
